export const notificationfiltersDataArray = [
  {
    text: "Audit Creation",
    iconClassName: "audit-creation-notification-icon",
  },
  {
    text: "Coder Review",
    iconClassName: "fa fa-comment coder-review-notification-icon",
  },
  {
    text: "esMD",
    iconClassName: "fa fa-paper-plane esmd-notification-icon",
  },
  {
    text: "QA Review",
    iconClassName: "fa fa-comment qa-review-notification-icon",
  },
  { text: "Reports", iconClassName: "reports-notification-icon" },
  { text: "Other", iconClassName: "fa fa-bell-o other-notification-icon" },
  {
    text: "Payer Task",
    iconClassName: "external-task-notification-icon",
    },
    {
        text: "Payer Audit",
        iconClassName: "external-task-notification-icon",
    },
    {
        text: "Payer Case",
        iconClassName: "external-task-notification-icon",
    },
];

export const categories = ["Production Upgrade", "Unplanned Downtime", "Other"];
export const delteSystemMessageConfirmMessage =
  "This message is currently active. Are you sure you want to delete?";
export const NOTIFICATION_AND_SYSTEM_MODULE_STATES = {
  NOTIFICATION_MODULE: "NOTIFICATION_MODULE",
  SYSTEM_MESSAGES_MODULE: "SYSTEM_MESSAGES_MODULE",
};
